import { initTooltip } from "../index.js";
const initMenu = (menu, props) => {
  if (!menu)
    return;
  const { onOpen, onClose } = props;
  const menuButton = menu.querySelector(".tds-menu-btn");
  const onTooltipOpen = (e) => {
    if (onOpen)
      onOpen(e);
    menuButton?.classList.add("tds-menu-btn--active");
  };
  const onTooltipClose = (e) => {
    if (onClose)
      onClose(e);
    menuButton?.classList.remove("tds-menu-btn--active");
  };
  const tooltip = menu.querySelector(".tds-tooltip");
  if (tooltip) {
    const tooltipProps = {
      isClickToOpen: true,
      closeOnBlur: true,
      onOpen: onTooltipOpen,
      onClose: onTooltipClose
    };
    initTooltip(tooltip, tooltipProps);
    if (tooltip.classList.contains("tds-tooltip--open")) {
      onTooltipOpen();
    } else {
      menuButton?.classList.remove("tds-menu-btn--active");
      onTooltipClose();
    }
  }
};
const initMenus = (props = {}) => {
  const { parent = document } = props;
  const menus = parent.querySelectorAll(".tds-menu");
  menus.forEach((menu) => {
    initMenu(menu, props);
  });
};
export {
  initMenu,
  initMenus
};
